import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as LightTheme } from '../../../../assets/images/themeSwitchers/LightTheme.svg';
import { ReactComponent as DarkTheme } from '../../../../assets/images/themeSwitchers/DarkTheme.svg';
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux';
import { appSlice } from '../../../../store/reducers/AppSlice';
import { BasicButton } from '../../buttons/BasicButton/BasicButton';

export const ThemeSwitcher: FC = () => {
  const { theme } = useAppSelector((state) => state.appReducer);
  const { chooseTheme } = appSlice.actions;
  const dispatch = useAppDispatch();

  const { t } = useTranslation();

  const handleTheme = () => {
    dispatch(chooseTheme(theme === 'light' ? 'dark' : 'light'));
  };

  return (
    <BasicButton className="theme-switcher" handleClick={handleTheme}>
      {theme === 'light' ? (
        <>
          <DarkTheme className="theme-switcher__icon" />
          <span className="theme-switcher__text">{t('header.darkTheme')}</span>
        </>
      ) : (
        <>
          <LightTheme className="theme-switcher__icon" />
          <span className="theme-switcher__text">{t('header.lightTheme')}</span>
        </>
      )}
    </BasicButton>
  );
};
